// src/api/client.ts
import { getCookie } from '../utils/utils';

export async function api<T = any>(
  url: string,
  options: RequestInit = {}
): Promise<T> {
  // Get CSRF token for non-GET requests
  const csrftoken = getCookie('csrftoken');
  
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    ...(options.headers as Record<string, string> || {}),
  };

  // Add CSRF token for state-changing requests
  if (options.method && options.method !== 'GET' && options.method !== 'HEAD') {
    (headers as Record<string, string>)['X-CSRFToken'] = csrftoken || '';
  }

  const res = await fetch(url, {
    credentials: 'include',
    headers,
    ...options,
  });

  if (!res.ok) {
    let body: any = null;
    try { body = await res.json(); } catch {}
    const message = body?.detail || body?.error || res.statusText;
    const err = new Error(message || `HTTP ${res.status}`) as Error & { body?: any };
    err.body = body;
    throw err;
  }

  if (res.status === 204) return undefined as T;
  return res.json() as Promise<T>;
}